// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForecastSummarySchema } from './v1/forecastSummarySchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listTaskSummariesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  resource: z.enum(["users", "projects"]).describe("Resource type to group summaries by"),
});

export const listTaskSummariesQueryParamsSchema = z.object({
  since: z.optional(z.string().date().describe("Filter tasks from this date")),
  until: z.optional(z.string().date().describe("Filter tasks up to this date")),
  completed: z.optional(z.enum(["true", "false"]).describe("Filter by completion status")),
  user_ids: z.optional(z.coerce.string().describe("Comma-separated user IDs to filter by")),
  project_ids: z.optional(z.coerce.string().describe("Comma-separated project IDs to filter by")),
  forecast_ids: z.optional(z.coerce.string().describe("Comma-separated task IDs to filter by")),
}).optional();

export const listTaskSummariesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Task summaries
 */
export const listTaskSummaries200Schema = z.array(z.lazy(() => v1ForecastSummarySchema));

/**
 * @description Unauthorized
 */
export const listTaskSummaries401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listTaskSummariesQueryResponseSchema = z.lazy(() => listTaskSummaries200Schema);
